
import axios from 'axios'
import qs from 'qs'
import request from '@/utils/request';

export function logins(data){
    return axios({
        url: '/user/login',
        method: 'post',
        data: data
    })
}

export function forgetPassword(data){
    return axios({
        url: '/enterprise/initphone.do',
        method: 'post',
        data: data
    })
}
export function makerlogins(data){
    return axios({
        url: '/maker/makerlogin.do',
        method: 'post',
        data: data
    })
}
export function loginCheck(data){
    return axios({
        url: '/maker/loginCheck.do',
        method: 'post',
        data: data
    })
}
export function getVerifyCode(data){
    return axios({
        url: '/sms/verifyCode',
        method: 'post',
        headers:{
            "Content-Type": "application/x-www-form-urlencoded"
        },
        data:qs.stringify(data)  
    })
}
export function loginSmsVerifyCode(data){
    return axios({
        url: '/user/login/smsVerifyCode',
        method: 'post',
        headers:{
            "Content-Type": "application/x-www-form-urlencoded"
        },
        data:qs.stringify(data)  
    })
}
export function getUserMessage(data){
    return axios({
        url: '/message/getUserMessage',
        method: 'get',
        data: data
    })
}
